

import React, { useState } from "react";
import logo from "../components/assets/Exclude.svg";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    
    try {
      // Replace with your actual API endpoint
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/users/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );
      
      if (response.ok) {
        const data = await response.json();
        
        // Store tokens in localStorage
        localStorage.setItem("accessToken", data.data.accessToken);
        localStorage.setItem("refreshToken", data.data.refreshToken);
        
        // Store user data if needed
        localStorage.setItem("userData", JSON.stringify(data.data.user));
        
        // Navigate to dashboard
        navigate("/dashboard");
      } else {
        const errorData = await response.json();
        setError(
          errorData.message || "Login failed. Please check your credentials."
        );
      }
    } catch (err) {
      setError("Network error. Please try again later.");
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="w-[100%] h-screen flex justify-center items-center bg-[#121316] relative overflow-hidden"
    >
      <div
        className="bg-[#1E1F22] rounded-2xl w-[500px] h-[auto] max-h-[90vh] p-4 text-center box-border
                  sm:w-[35%] sm:min-h-[400px]"
      >
        <img
          src={logo}
          alt="Spatial Grid Logo"
          className="mt-12 w-[100px] mx-auto sm:mt-5 sm:w-[80px]"
        />
        
        <h1 className="text-white text-[37px] font-semibold mt-4">
          Welcome to Spatial Grid
        </h1>
        <p className="text-[#8A8A8A] text-sm tracking-normal leading-relaxed mt-2">
          Log in with your email.
        </p>
        
        <hr className="w-[360px] mx-auto border-t text-[#8A8A8A] my-4 sm:w-[85%]" />
        
        {error && <p className="text-red-500 text-sm mb-2">{error}</p>}
        
        <form
          onSubmit={handleLogin}
          className="flex flex-col items-center gap-4"
        >
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="text-white text-center w-[360px] h-[42px] rounded-md bg-[#4A4A50] placeholder:text-[#A39F9F]
                   focus:outline-none border-none sm:w-[85%]"
          />
          
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="text-white text-center w-[360px] h-[42px] rounded-md bg-[#4A4A50] placeholder:text-[#A39F9F]
                   focus:outline-none border-none sm:w-[85%]"
          />
          
          <button
            type="submit"
            disabled={loading}
            className="w-[365px] h-[42px] bg-[#26272a] text-[#C8C4C4] rounded-md text-sm cursor-pointer
                   hover:bg-[#1a1a1c] transition sm:w-[85%] sm:mt-4"
          >
            {loading ? "Loading..." : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;